module.exports = __webpack_public_path__ + "static/media/bg.77428cd4.svg";